import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

/** Generic fallback. Data-heavy views use layout-matched skeletons instead. */
export function LoadingState({ label = 'Loading' }: { label?: string }) {
  return (
    <Stack role="status" alignItems="center" spacing={3} sx={{ py: 16 }}>
      <CircularProgress aria-hidden />
      <Typography color="text.secondary">{label}…</Typography>
    </Stack>
  );
}
